<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container fluid class="py-0" :class="{}">
            <v-row>
                <v-col style="position: relative">
                    <img  alt="Hero Banner Image" src="/images/main/bg-kontakt.jpg" :style="{
                        height: imageHeight
                    }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;
                        object-position: top;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%); display: flex"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <v-container fluid>
                            <v-row>
                                <v-col :class="{'flex-row' : !isMobile}" cols="12">
                                    <div :style="{'padding-right' : isMobile ? '' : '200px'}">
                                    <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                                    <h1 style="color: white" class="mb-4">{{ $t("titleScreens.contact") }}</h1>
                                    <a :href="$getPhoneLink()">
                                        <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                                        }}</v-btn>
                                    </a><br>
                                    <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{
                                        $t("landing.contactButtonText")
                                        }}</small>
                                    </div>
                                    <div style="color: white" class="mt-4" :class="{'pl-4': isMobile, 'mt-8 ': isMobile}">
                                        <p style="color: white" class="pb-2"><a style="text-decoration: none; color: white" :href="'tel:' + decodedPhone">
                                            <v-icon class="pr-6">mdi-phone</v-icon> {{ decodedPhone }}
                                        </a>
                                        </p>
                                        <p style="color: white" class="pb-2"><a style="text-decoration: none; color: white" :href="'mailto:' + decodedMail">
                                            <v-icon class="pr-6">mdi-email</v-icon> {{ decodedMail }}
                                        </a>
                                        </p>
                                        <p class="pb-2">
                                            <v-icon class="pr-6">mdi-map-marker</v-icon> Annastr. 9<br>
                                            <v-icon style="opacity: 0">mdi-map-marker</v-icon> 34119 Kassel <br>
                                        </p>
                                        <a style="color: rgb(var(--v-theme-light))"
                                            href="https://www.google.com/maps/place/Annastra%C3%9Fe+9,+34119+Kassel,+Deutschland/@51.3169437,9.4757303,17z/data=!3m1!4b1!4m5!3m4!1s0x47bb3f46f3361cf1:0x7657b672181e3fab!8m2!3d51.3169404!4d9.477919?shorturl=1">
                                            <v-icon class="pr-6">mdi-arrow-right</v-icon> {{ $t("basics.directions") }}
                                        </a>
                                        <br>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </div>
                </v-col>
            </v-row>
            <WaveVue :color="'rgb(var(--v-theme-primary))'" :negative="true" :height="WaveHeight"
                :style="{ 'margin-top': HeroWaveMargin }" style="z-index: 2; position: relative;" />
            <v-row class="primary-background mx-0" style="margin-top: -1px">
                <v-spacer />
                <v-col :cols="textCols" style="padding: 80px 16px 160px">
                    <h2 class="mb-4" style="color: rgb(var(--v-theme-light))">{{ $t("contact.hintTitle") }}</h2>
                    <p v-html="$t('contact.hintText')" style="color: rgb(var(--v-theme-light))"></p>
                </v-col>
                <v-spacer />
            </v-row>
            <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true" :height="WaveHeight"
                :style="{ 'margin-top': WaveMargin }" style="z-index: 2; position: relative; margin-left: -1px" />

        </v-container>
        <v-container fluid>
            <v-row class="mt-16">
                <v-spacer />
                <v-col :cols="mainCols">
                    <v-card flat class="pb-8" id="contactFormId"
                        :style="{ 'border-radius': isMobile ? '0px !important' : '' }">
                        <v-form ref="contactForm" class="pt-8" style="width: 100%" v-if="!contactDone">
                            <v-container fluid style="background-color: rgb(var(--v-theme-light));"
                                :class="{ '!isMobile': 'mx-16' }">
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-model="name" :label="$t('basics.name') + '*'"
                                            :rules="[requiredRule, max256]" variant="outlined"></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col>
                                        <v-text-field variant="outlined" :label="$t('basics.email') + '*'"
                                            v-model="email" :rules="emailRules"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field variant="outlined" :label="$t('basics.phone') + '*'"
                                            v-model="phone" :rules="[requiredRule, max256]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field variant="outlined" :label="$t('basics.subject') + '*'"
                                            v-model="subject" :rules="[requiredRule, max256]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea variant="outlined" :label="$t('basics.message') + '*'"
                                            v-model="message" :rules="[requiredRule, max256]"></v-textarea>
                                    </v-col>
                                </v-row>

                                <v-row @click="privacyAccpted = !privacyAccpted">
                                    <v-col cols="auto">
                                        <v-icon v-if="!privacyAccpted">mdi-checkbox-blank-outline</v-icon>
                                        <v-icon color="primary" v-else>mdi-checkbox-marked</v-icon>
                                    </v-col>
                                    <v-col>
                                        <div v-html="$t('messages.contactCheckboxText') + '*'"></div>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col :cols="12" style="display: flex">
                                        <v-btn @click="confirm" :loading="loading" flat :disabled="!privacyAccpted"
                                            class="primaryButton" large block>{{
                                                $t("basics.send")
                                            }}</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>

                        <div v-else style="width: 100%">
                            <div style="position: relative" class="mb-4">
                                <v-img src="/images/main/background.jpeg" class="fadedImg"
                                    style="width: 100%; height: auto; border-top-right-radius: 12px; border-top-left-radius: 12px;" />
                                <div class="fadedImgMask">
                                </div>
                            </div>
                            <v-container fluid style="background-color: rgb(var(--v-theme-light));" class="pa-16">
                                <v-row>
                                    <v-col class="text-center">
                                        <h2>{{ $t("messages.contactDoneTitle") }}</h2>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="text-center">
                                        <h3 v-html="$t('messages.contactDoneMessage')"></h3>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </div>
                    </v-card>
                </v-col>
                <v-spacer />
            </v-row>
        </v-container>
    </div>
</template>



<script>
export default {
    name: "aboutMeComponent",

    data() {
        return {
            encodedEmail: 'a29udGFrdEBwcmF4aXMta2VpbGJlcmcuZGU=',
            encodedPhone: 'KzQ5IDE1MSA1MDg1IDA5NDI=',


            email: undefined,
            phone: undefined,
            subject: undefined,
            message: undefined,

            name: undefined,

            privacyAccpted: false,

            contactDone: false,

            loading: false,

            requiredRule: (v) => !!v || this.$t("messages.required"),
            emailRules: [
                (v) => !!v || this.$t("messages.required"),
                (v) => /.+@.+\..+/.test(v) || this.$t("messages.wrongEMailFormat"),
            ],
            max256: (v) => v.length <= 256 || this.$t("messages.tooLong", { count: 256 }),
            max20: (v) => v.length <= 20 || this.$t("messages.tooLong", { count: 20 }),
            requiredArray: (v) => (!!v && v.length > 0) || this.$t("messages.required"),
        }
    },


    computed: {
        decodedMail() {
            return atob(this.encodedEmail)
        },
        decodedPhone() {
            return atob(this.encodedPhone)
        },
        leftAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        rightAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        leftServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "8";
                case "lg":
                    return "8";
                case "xl":
                    return "8";
                case "xxl":
                    return "8";
                default:
                    return "8";
            }
        },
        rightServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "4";
                case "lg":
                    return "4";
                case "xl":
                    return "4";
                case "xxl":
                    return "4";
                default:
                    return "4";
            }
        },
        marginLeftOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12px";
                case "sm":
                    return "50px";
                case "md":
                    return "50px";
                case "lg":
                    return "100px";
                case "xl":
                    return "50px";
                case "xxl":
                    return "50px";
                default:
                    return "50px";
            }
        },
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90%";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "5%";
                case "sm":
                    return "5%";
                case "md":
                    return "5%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
        spacerHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "100px";
                case "sm":
                    return "100px";
                case "md":
                    return "100px";
                case "lg":
                    return "100px";
                case "xl":
                    return "100px";
                case "xxl":
                    return "100px";
                default:
                    return "100px";
            }
        },
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        imageCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        textCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 11;
                case "sm":
                    return 11;
                case "md":
                    return 5;
                case "lg":
                    return 5;
                case "xl":
                    return 3;
                case "xxl":
                    return 3;
                default:
                    return 3;
            }
        },
        navCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 2;
                case "sm":
                    return "auto";
                case "md":
                    return "auto";
                case "lg":
                    return "auto";
                case "xl":
                    return "auto";
                case "xxl":
                    return "auto";
                default:
                    return "auto";
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        WaveHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "30px";
                case "sm":
                    return "30px";
                case "md":
                    return "120px";
                case "lg":
                    return "120px";
                case "xl":
                    return "120px";
                case "xxl":
                    return "120px";
                default:
                    return "120px";
            }
        },
        HeroWaveMargin() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "-48px";
                case "sm":
                    return "-48px";
                case "md":
                    return "-138px";
                case "lg":
                    return "-138px";
                case "xl":
                    return "-138px";
                case "xxl":
                    return "-138px";
                default:
                    return "-138px";
            }
        },
        WaveMargin() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "-30px";
                case "sm":
                    return "-30px";
                case "md":
                    return "-120px";
                case "lg":
                    return "-120px";
                case "xl":
                    return "-120px";
                case "xxl":
                    return "-120px";
                default:
                    return "-120px";
            }
        },
    },

    mounted() {
        if (window.location.hash === "#contactFormId") {
            this.$nextTick(() => {
                setTimeout(() => {
                    const el = document.getElementById("contactFormId")

                    if (el) {
                        const offset = 100
                        const y = el.getBoundingClientRect().top + window.scrollY - offset

                        window.scrollTo({
                            top: y,
                            behavior: "smooth",
                        })
                    }
                }, 100)
            })
        }
    },

    methods: {
        async confirm() {
            const { valid } = await this.$refs.contactForm.validate()

            if (valid) {
                this.loading = true

                let formData = {
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    subject: this.subject,
                    message: this.message
                }


                this.axios.post(this.axios.defaults.baseURL + "user/contact/post/", formData)
                    .then((resp) => {
                        this.loading = false
                        this.contactDone = true
                    })
                    .catch((e) => {
                        this.loading = false
                        console.log(e)
                        window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
                    })

            }
        }
    }
}

</script>